import { useQuery } from '@tanstack/react-query';

import { useAppEnvironmentContext } from '../contexts/appEnvironmentContext';
import { useOfficeContext } from './addin/office';

// Suggested by GitHub Copilot
export const isMacOS = () => {
  return /Mac|iPod|iPhone|iPad/.test(navigator.userAgent);
};

export const useAppPlatform = (): 'web' | 'excel' | 'powerpoint' => {
  const { isExcel } = useOfficeContext();
  const { appEnvironment } = useAppEnvironmentContext();
  return appEnvironment === 'web' ? 'web' : isExcel ? 'excel' : 'powerpoint';
};

/*
 * Checks the build timestamp to ensure the app is on the latest version. The check
 * is done initially and whenever the user refocuses the browser window. If the build
 * timestamp from the server does not match the currently loaded app's build timestamp,
 * the page will automatically reload to ensure the user is using the latest version.
 * No work will be lost since we now cache user changes to the diagram.
 */
export const useNewVersionCheck = () => {
  useQuery({
    queryKey: ['version'],
    queryFn: async () => {
      if (process.env.VERSION_ENDPOINT) {
        const res = await fetch(process.env.VERSION_ENDPOINT, {
          cache: 'no-cache',
        });
        const { buildTimestamp } = await res.json();
        if (buildTimestamp && buildTimestamp !== process.env.BUILD_TIMESTAMP) {
          window.location.reload();
        }
      }
      return null;
    },
    refetchOnWindowFocus: true,
  });
};
